<template>

  <div id="text">

  <article class="message">
    <div class="message-body">
      <div class="title is-5">Bubble Chart - Pragmatics</div>
      <div class="text">This bubble chart shows two variables; <em>pragmatics</em>, or sphere of impact (scaled 1-5 in terms of colour opacity in magenta, from public to private), and audience share, scaled relatively in terms of bubble-size. These data concern only broadcast TV series.</div>
      <div class="text">It allows the comparison of a scale of impact concerning the primary subject of each investigation (concerning what may be called the <em>social importance</em> of the entity being investigated), against the popularity of each show amongst the viewing public (what may be thought of as a <em>marketplace</em> scale of <em>what interests the public</em>).
      </div>
      <div class="text">It is proposed that interactive text boxes containing the details of each investigation will arise in mouse-over, and that further interactive materials (including bespoke videos and learning materials, concerning a top 10 canon in the field) may be made available.</div>
    </div>
  </article>

  <section class="section">
        <div class="container">
            <GChart
                    type="BubbleChart"
                    :data="chartData"
                    :options="chartOptions"
                    style="width: 1200px; height: 600px;"
                    @ready="onChartReady"
                    ref="gChart"
            />
        </div>
    </section>

    <div class="content">
      <strong>Variable:</strong>
      <ul>
        <li>Pragmatics involved (scaled 1-5; from public to private)</li>
        <li>Audience (viewing figures for TV series): scaled in terms of bubble-size</li>
      </ul>
    </div>

  </div>
</template>

<script>

    import { GChart } from "vue-google-charts";

    export default {
        name: "BubbleChartPragmatics",
        props: {
          mydata : []
        },
        components: {
            GChart
        },
        data() {
            return {
                chartData: this.mydata,
                chartOptions: {

                    title: 'Events depicted on a colour scale of PRAGMATICS (1-5)',
                    colorAxis: {colors: ['#FCCFFF', '#F00FFF']},
                    hAxis: {
                        title: 'Year',
                        format: ' ',
                        viewWindow:{ min: 2000, max: 2020 },
                        gridlines: {color: '#FFFFFF'}
                    },
                    vAxis: {title: 'Events', viewWindow: {min: 0, max: 12}, gridlines: {color: '#FFFFFF'}},
                    bubble: {textStyle: {fontSize: 11, auraColor: 'none'}},
                    tooltip: {
                        // trigger: 'none'
                    },
                    width: 1200,
                    height: 600
                },
                id : '',
                date: '',
                event : '',
                pragmatics: '',
                audience: ''
            };
        },
        methods: {
            onChartReady(chart, google) {
                // now we have google lib loaded. Let's create data table based using it.
                this.createDataTable(chart, google);
            },

            // Array will be automatically processed with visualization.arrayToDataTable function
            createDataTable(chart, google) {

              var data = new google.visualization.DataTable();
              data.addColumn('string', 'Id');
              data.addColumn('number','Year');
              data.addColumn('number','Event number');
              data.addColumn('number','Pragmatics');
              data.addColumn('number', 'Audience');

              let rows = [];

              for(let index in this.chartData){
                if(this.chartData.hasOwnProperty(index)){
                  this.id = this.chartData[index].id.toString();
                  this.date = this.chartData[index].date;
                  this.date = parseInt(this.date);
                  this.event = this.chartData[index].event;
                  this.pragmatics = this.chartData[index].pragmatics;
                  this.audience = this.chartData[index].audience;

                  rows[index] = [];
                  rows[index][0] = this.id;
                  rows[index][1] = this.date;
                  rows[index][2] = this.event;
                  rows[index][3] = this.pragmatics;
                  rows[index][4] = this.audience;
                }
              }
              data.addRows(rows);

              var view = new google.visualization.DataView(data);
              chart.draw(view, this.chartOptions);
            }
        }
    }

</script>

<style scoped>

  #text {
    width: 100%;
  }

  .text {
    padding: 5px 0;
  }

  em {
    font-weight: 500
  }

</style>
